import { RADAR_LINES } from '../data/scoreRadar';

export const scoreMapping = (input: { [key: string]: string | number }): (number | string)[] | [] => {
  if (!input) {
    return [];
  }

  return RADAR_LINES.map(({ mappingName }) => input[mappingName]);
};
